import cn from "@/v2-ui/utils/utils.cn"
import { DotText } from "@/v2-backoffice-client/components/dot"
import InfoGrid, {
  type InfoGridProps,
  createInfoGridFields,
} from "@/v2-backoffice-client/components/infoGrid"
import type { NavLayerFragment } from "@/v2-backoffice-client/navlayer/__types__/navlayer.fragment"

const FIELDS = createInfoGridFields<NavLayerFragment>({
  fields: {
    FeatureCode: {
      label: "Feature Code",
      accessor: "FeatureCode",
    },
    IsEnabled: {
      label: "Status",
      accessor: "IsEnabled",
      renderValue({ value }) {
        return (
          <DotText variant={value ? "success-1" : "destructive"}>
            {value ? "Enabled" : "Disabled"}
          </DotText>
        )
      },
    },
  },
})

export type NavLayerViewInfoProps = Omit<
  InfoGridProps<NavLayerFragment>,
  "data" | "fields"
> & {
  navLayer: NavLayerFragment | null | undefined
}

function NavLayerViewInfo(props: NavLayerViewInfoProps) {
  const { navLayer, className, ...infoGridProps } = props

  return (
    <InfoGrid
      id="navlayer-info"
      className={cn("navlayer-view-info", className)}
      data={navLayer}
      fields={FIELDS}
      {...infoGridProps}
    />
  )
}

export default NavLayerViewInfo
